import {_urlAuth, _urlDescriptors, _urlProfile, request} from "../api";
import {PROFILE_CONSTS} from "../constants";

export const GetUserProfile = () => {
    let requestData = {
        url: `${_urlProfile}`,
        method: "GET",
    };

    return dispatch => {
        return request(requestData)
            .then(async (res) => {
                const data = res && res.data;

                await dispatch({
                    type: PROFILE_CONSTS.GET_USER_PROFILE,
                    payload: data
                })
                return data
            })
    };
};
export const GetAuthCheck = () => {
    let requestData = {
        url: `${_urlAuth}/check`,
        method: "GET",
    };

    return dispatch => {
        return request(requestData)
            .then(async (res) => {
                const data = res && res.data;

                await dispatch({
                    type: PROFILE_CONSTS.GET_AUTH_CHECK,
                    payload: data
                })
            })
    };
};

export const SetUserAvatar = (data) => {
    return async dispatch => {
        await dispatch({
            type: PROFILE_CONSTS.SET_USER_PROFILE,
            payload: data
        })
    };
};
export const ClearProfile = () => {
    return async dispatch => {
        await dispatch({
            type: PROFILE_CONSTS.CLEAR_PROFILE
        })
    };
};

export const UpdateConfluenceInfoService = (data) => {
    return async dispatch => {
        await dispatch({
            type: PROFILE_CONSTS.UPDATE_CONFLUINCE_INFO,
            payload: data
        })
    };
};

export const GetDescriptorsService = (id) => {
    let requestData = {
        url: `${_urlDescriptors}?person_id=${id}`,
        method: "GET",
    };

    return dispatch => {
        return request(requestData)
            .then(async (res) => {
                const data = res && res.data;
                await dispatch({
                    type: PROFILE_CONSTS.GET_DESCRIPTORS,
                    payload: data
                })
            })
    };
};

export const UpdateMainDescriptorService = (id, data) => {
    let requestData = {
        url: `${_urlDescriptors}/${id}`,
        method: "PATCH",
        data
    };
        return request(requestData)
            .then(async (res) => {
                const data = res && res.data;
            })
};

export const DeleteDescriptorService = (id, data) => {
    let requestData = {
        url: `${_urlDescriptors}/${id}`,
        method: "DELETE",
        data
    };
        return request(requestData)
            .then(async (res) => {
                const data = res && res.data;
            })
};

